import React, { Fragment, Component } from "react";
import i18n, { t } from "i18next";
import { errorHandler, withRouter } from "../../utils/GlobalFunctions";
import InputMask from "react-input-mask";
import { Form, Input, Button,  Select, Table, Modal, Checkbox, message } from "antd";
import { getBaseURL } from "../../utils/axiosRequest";
import { LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { isMobile } from "react-device-detect";

const { Search } = Input;


export class FillForm extends Component{
    constructor(props) {
        super(props);
    
        this.state = {
          form_id: null,  
          elemService: [],
          elemVAT: [],
          grandTotal: 0,
          tinValue: "",
          telValue: "",
          data: null,
          requestFailed: false,
          userforms: null,
          isLoaded: false,
          showInvoice: false,
          submitButtonDisabled: false,
          contractChecked: false,
          areas: [],
          isTinLoading: false,

        };
    }

    componentDidMount() {
        this.setData();
        this.loadAreas();   
    }

    setData() {
        const form = this.props.location.state.formItem;
        let newArr = [];
        let vatArr = [];
        let sum = 0;
        this.setState({form_id: form.form_id});
        form.services.forEach((elem, id)=>{
            newArr.push({
                'id': elem.service_id, 
                'qty': elem.unit_qty, 
                'dsc': null, 
                'price': (elem.amount/100).toFixed(2), 
                'total': elem.selectable ? (0).toFixed(2) : (elem.unit_qty * elem.amount/100).toFixed(2)
            }); 
            sum += parseFloat(newArr[id].total);
            if(elem.vat) {
                vatArr.push({
                    'id': elem.vat.service_id, 
                    'qty': elem.vat.unit_qty / 100, 
                    'name': elem.vat.name,
                    'is_tax': elem.vat.is_tax,
                    'dsc': null, 
                    'price': (elem.amount * elem.vat.value/ 100).toFixed(2), 
                    'total': (elem.amount * elem.unit_qty * elem.vat.unit_qty * elem.vat.value/100).toFixed(2)
                }); 
                sum += parseFloat(vatArr[id].total);
            }  
                
            
            }
        );

        this.setState({elemService: newArr, elemVAT: vatArr, grandTotal: sum, isLoaded: true});
    }

    loadAreas = () => {
        // Проверяем, есть ли данные в sessionStorage
        const cachedAreas = sessionStorage.getItem('tj_areas');
        if (cachedAreas) {
            try {
                const areas = JSON.parse(cachedAreas);
                this.setState({ areas });
                return;
            } catch (error) {
                console.error('Error parsing cached areas:', error);
                sessionStorage.removeItem('tj_areas');
            }
        }

        // Загружаем данные с сервера
        fetch(`${getBaseURL()}common/rni_regions`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.sessionStorage["access_token"],
            },
        })
        .then(response => errorHandler(response, 'FillForm.jsx - loadAreas', this.props.navigate))
        .then((responseJson) => {
            if (responseJson && Array.isArray(responseJson)) {
                // Сохраняем в sessionStorage
                sessionStorage.setItem('tj_areas', JSON.stringify(responseJson));
                this.setState({ areas: responseJson });
            }
        })
        .catch((error) => {
            console.error('Error loading areas:', error);
        });
    }
    
    componentDidUpdate() {}

    onFinish = (fieldsValue) => {
        this.setState({submitButtonDisabled: true});
        let newArr = [];
        newArr = this.state.elemService.filter((elem, _) => elem.total !== '0.00');
        let phonenumber = fieldsValue['phonenumber'];
        let val = fieldsValue;
        val['islegalentity'] = this.state.contractChecked;
        val['Плательщик'] = fieldsValue['customer']; 
        val['РМА'] = fieldsValue['tin'];
        
        // Находим выбранный район по rni_id и извлекаем оба ID
        const selectedArea = this.state.areas.find(area => area.rni_id === fieldsValue['area']);
        if (selectedArea) {
            val['rni_id'] = selectedArea.rni_id;
            val['area_id'] = selectedArea.area_id;
        }
        
        delete val['customer']; delete val['tin']; delete val['phonenumber']; delete val['area'];
        //console.log(val);
        //console.log(this.state.contractChecked);
        //console.log('Elements', newArr);
        //console.log('VATs', this.state.elemVAT);
        fetch(`${getBaseURL()}invoices/new`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + window.sessionStorage["access_token"],
            },
            body: JSON.stringify({
                'form_id': this.state.form_id,
                'bill_to': val,
                'customer_phonenumber': phonenumber, 
                'services': newArr.concat(this.state.elemVAT)
            })
          }).then(response =>{ return errorHandler(response, 'FillForm.jsx - onFinish', this.props.navigate) }
          ).then((responseJson) => {
            this.props.form.resetFields();
            Modal.info({  
                title: 'Ҳисобномаи нав сохта шуд!',
                content: 
                <div>
                    <div className="font-bold">{`№ ${responseJson.invoice_number}`}</div>
                    <div className="text-justify">{`${responseJson.subject[i18n.language]}`}</div>
                    <div className="font-bold">{`${(responseJson.amount_due/100).toFixed(2)} сомони`}</div>
                </div>
            });
            
            this.props.navigate('/payments/forms')
        }); 
        
    }

    handleFile = (e) => {

    };


    handleSearchTin = async (value) => {
        if (!/^\d{9}$/.test(value)) {
          message.error("РМА должен содержать ровно 9 цифр");
          return;
        }
    
        try {
          if (!value) return;
    
          // Показываем индикатор загрузки
          this.setState({ isTinLoading: true });
    
          const url = `${getBaseURL()}invoices/tin/verify/${value}`;
    
          const response = await fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + window.sessionStorage["access_token"],
            },
          });
    
          if (!response.ok) {
            throw new Error("Ошибка при проверке TIN");
          }
    
          const data = await response.json();
    
          if (data.errorCode === 0) {
            const customer = data.FullName || '';
            this.props.form.setFieldsValue({ customer });
          } else {
            alert("Не удалось найти ФИО для данного РМА. Заполните пожалуйста вручную");
          }
        } catch (err) {
          console.error(err);
          message.error("Ошибка при получении данных");
        } finally {
          // Скрываем индикатор загрузки в любом случае
          this.setState({ isTinLoading: false });
        }
      };

    numHandler = (e) => {
        const { value: inputValue } = e.target;
        const reg = /^-?\d*(\.\d*)?$/;
        if ((reg.test(inputValue) || inputValue === '' || inputValue === '-') && inputValue.length < 10) {
            this.setState({telValue: inputValue});
        }
    };

    tinHandler = (e) => {
        const { value: inputValue } = e.target;
        const reg = /^-?\d*(\.\d*)?$/;
        if ((reg.test(inputValue) || inputValue === '' || inputValue === '-') && inputValue.length < 10) {
            this.setState({tinValue: inputValue});     
        }
    };

    contractHandler = (e) => {
        const { checked } = e.target;
        this.setState({contractChecked: checked, });
    };

render() {
    const { telValue, tinValue, grandTotal, elemService, elemVAT, isTinLoading } = this.state;
    const {formItem} = this.props.location.state;
    const {translation} = this.props;
    
    const form_columns = [
        {
            title: translation("DESCRIPTION"),
            width: "54%",

            dataIndex: 'name',
            key: 'name',
            render: (name, row, rowIndex) => {
                return ( <div>
                    {row.selectable ?
                    <>
                    <Checkbox value={row.key} 
                        onChange={(e)=>{
                            let newArr = [...elemService];
                            let sum = 0;
                            let q_ty = 0;
                            if(e.target.checked) {
                                q_ty = parseFloat(elemService[rowIndex].qty);
                            }
                            else {
                                q_ty = 0;
                            }
                            newArr[rowIndex].total = (q_ty * parseFloat(newArr[rowIndex].price)).toFixed(2);
                            newArr.forEach((num) => {sum += parseFloat(num.total);});
                            this.setState({elemService: newArr, grandTotal: sum});
                        }
                    }
                    >{name}
                    </Checkbox>
                    </>  
                    : <div className="w-full">{name}</div>}
                    {row.vat? <div className="md:ml-[4rem] py-2">{row.vat.name}</div>:<></>
                    }
                    </div>)
                ;
            },
        },
        {
            title: translation("MEASUREMENT"),
            width: "8%",
            align: 'center',
            dataIndex: 'unit_name',
            key: 'unit_name',
            render: (unit_name, row) => {
                return (
                    <div>
                        <div className="w-full flex justify-center">{unit_name}</div>
                        {row.vat? <div className="py-2">{row.vat.unit_name}</div>:<></>
                        }
                    </div>
                );
            },
        },
        {
            title: translation("QTY"),
            width: "8%",
            dataIndex: 'unit_qty', 
            key: 'unit_qty',        
            render: (unit_qty, row, rowIndex) => {
                const q_ty = elemService[rowIndex]?.qty
                return (<div>
                    {row.discount !== null ?
                    <Select className="text-center"
                        id={"qty_" + row.service_id}
                        defaultValue="1"
                        style={isMobile ? { fontSize: 12, width: 80 } : {fontSize: 12, width: 140}}
                        onChange={(value, option)=>{
                            //console.log('Select changed', value)
                            let newArr = [...elemService];
                            let sum = 0;
                            newArr[rowIndex].qty = 1 - value;
                            if (value !== 0) {newArr[rowIndex].dsc = option.label;} else {newArr[rowIndex].dsc = null};
                            newArr[rowIndex].total = ((parseFloat(newArr[rowIndex].qty) || 0) * parseFloat(newArr[rowIndex].price)).toFixed(2);
                            newArr.forEach((num) => {sum += parseFloat(num.total);});
                            this.setState({elemService: newArr, grandTotal: sum});
                        }}
                        options={row.discount}
                    />
                    :row.unit_qty ===0 ?
                    <input id={"qty_" + rowIndex} className="text-center bg-white border px-2 py-1 rounded-[4px] w-full mx-auto" type="number" name="price"
                        defaultValue={q_ty}
                        onChange={(e)=>{
                            console.log('Input changed', e.target.value)
                            let newArr = [...elemService];
                            let vatArr = [...elemVAT];
                            let sum = 0;
                            newArr[rowIndex].qty = e.target.value;
                            newArr[rowIndex].total = ((parseFloat(newArr[rowIndex].qty) || 0) * parseFloat(newArr[rowIndex].price)).toFixed(2);
                            newArr.forEach((num) => {sum += parseFloat(num.total);});
                            //console.log(newArr);
                            if(row.vat) {
                                vatArr[rowIndex].price = (parseFloat(newArr[rowIndex].price * row.vat.value) * parseFloat(newArr[rowIndex].qty) ).toFixed(2);
                                vatArr[rowIndex].total = (parseFloat(vatArr[rowIndex].price) * parseFloat(vatArr[rowIndex].qty) ).toFixed(2);
                                
                            }
                            vatArr.forEach((num) => {sum += parseFloat(num.total);});
                            this.setState({elemService: newArr, elemVAT: vatArr, grandTotal: sum});
                        }}
                    />
                    :<div className="w-full flex justify-center">{q_ty}</div>}
                    {row.vat? <div className="w-full flex justify-center py-2">{(elemVAT[rowIndex]?.qty * 100).toFixed(2)}</div>:<></>
                    }
                    </div>
                );
            },
        },
        {
            title: translation("PRICE"),
            width: "15%",
            align: 'right',
            dataIndex: 'amount',
            key: 'price',
            render: (amount, row, rowIndex) => {
                const price = elemService[rowIndex]?.price
                return (
                    <div> 
                    {row.amount === 0 ?
                    <input id={"price_" + rowIndex} className="text-right bg-white border px-2 py-1 rounded-[4px] w-full mx-auto" name="price"
                        defaultValue={price}
                        onChange={(e)=>{
                            let newArr = [...elemService];
                            let vatArr = [...elemVAT];
                            let sum = 0;
                            newArr[rowIndex].price = e.target.value;
                            newArr[rowIndex].total = ((parseFloat(newArr[rowIndex].price) || 0) * parseFloat(newArr[rowIndex].qty));
                            newArr.forEach((num) => {sum += parseFloat(num.total);});
                            //console.log(newArr);
                            if(row.vat) {
                                vatArr[rowIndex].price = e.target.value * row.vat.value;
                                vatArr[rowIndex].total = (parseFloat(vatArr[rowIndex].price) * parseFloat(vatArr[rowIndex].qty) ).toFixed(2);
                                
                            }
                            vatArr.forEach((num) => {sum += parseFloat(num.total);});
                            this.setState({elemService: newArr, elemVAT: vatArr, grandTotal: sum});
                        }}
                    />
                    : <div className="w-full flex justify-end">{elemService[rowIndex]?.price}</div>}
                    {
                        row.vat ? <div className="w-full flex justify-end py-2">{parseFloat(elemVAT[rowIndex]?.price).toFixed(2)}</div>:<></>
                    }
                    </div>
                );
            },
        },
        {
            title: translation("SUM"),
            width: "15%",
            align: 'right',
            dataIndex: 'amount',
            key: 'amount',
            render: (amount, row, rowIndex) => {
                return ( <div>
                    <div className="w-full flex justify-end">{ elemService[rowIndex]?.total }</div>
                    {row.vat ? <div className="w-full flex justify-end py-2">{elemVAT[rowIndex]?.total}</div>:<></>}
                    </div>
                    );
            },
        },
    ]
    
return (
    <div className="w-full">{!formItem && !this.state.isLoaded 
        ? <div className="w-full flex justify-center"><LoadingOutlined style={{ fontSize: 24, }} spin /></div>
        : <div className="block">
            <Form id="myform" className="w-full" form={this.props.form} onFinish={this.onFinish}>
            <div className="sticky top-0 z-[99]">
                <div className="bg-[#18526B] flex justify-center p-2 text-white">
                    <div className="ml-4 flex text-white items-center sm:text-m md:text-l lg:text-l xl:text-2xl m-0 border-r-2 pr-3">
                        {formItem.form_id < 10 ? `0${formItem.form_id}` : formItem.form_id}
                    </div>
                    <div className="w-full pl-[2rem] flex items-center text-white sm:text-base md:text-lg m-0">
                        {formItem.form_name.tj}
                    </div>  
                </div>
                <div className="w-full mb-[2rem]">
                    <div className="sm:block md:flex bg-[#fff] rounded-b-[8px] py-4 shadow-lg">
                    <div className="flex flex-col md:w-[30%] space-y-2 sm:px-4 md:px-5 lg:px-5 xl:px-8">
                            <p className="m-0 text-xs text-[#6A6A6A] pl-3">РМА</p>
                            <Form.Item name="tin" className="m-0">
                  <Search
                    required
                    name="tin"
                    placeholder="РМА-и пардохткунанда"
                    maxLength={9}
                    minLength={9}
                    className="rounded-lg shadow-sm"
                    loading={isTinLoading}
                    onSearch={(value) => {
                      if (!value || !/^\d{9}$/.test(value)) {
                        alert("РМА должен содержать ровно 9 цифр!");
                        return;
                      }
                      this.handleSearchTin(value);
                    }}
                  />
                </Form.Item>
                        </div>

                        <div className="flex flex-col md:w-[30%] space-y-2 sm:px-4 md:px-5 lg:px-5 xl:px-8">
                            <p className="m-0 text-xs text-[#6A6A6A] pl-3">
                            {translation("PAYER")}
                            </p>
                            <Form.Item name='customer' className="m-0">
                                <Input
                                    className="bg-white border px-3 py-2 rounded-lg"
                                    type="text"
                                    name="customer"
                                    required
                                />
                            </Form.Item>
                        </div>
                        <div className="flex flex-col md:w-[30%] space-y-2 sm:px-4 md:px-5 lg:px-5 xl:px-8">
                            <p className="m-0 text-xs text-[#6A6A6A] pl-3">
                            {translation("PHONE_NUMBER")}
                            </p>
                            <Form.Item name='phonenumber' className="m-0">
                            <Input
                                className="bg-white border px-3 py-2 rounded-lg"
                                type="text"
                                name="tel"
                                required
                                value={telValue}
                                onChange={this.numHandler}
                            />
                            </Form.Item>
                        </div>
                        
                        <div className="flex flex-col md:w-[30%] space-y-2 sm:px-4 md:px-5 lg:px-5 xl:px-8">
                            <p className="m-0 text-xs text-[#6A6A6A] pl-3">
                                 Ноҳия/шаҳр
                            </p>
                            <Form.Item name='area' className="m-0">
                                <Select
                                    className=""
                                    placeholder='Ноҳия/шаҳр интихоб намоед'
                                    showSearch
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={this.state.areas.map(area => ({
                                        label: area.name,
                                        value: area.rni_id
                                    }))}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="sm:block md:flex bg-[#fff] rounded-b-[8px] py-4 shadow-lg">
                        
                        {formItem?.fill_form.map((elem) => {
                            if (elem.type === "number") {
                            return (
                                <Fragment key={elem.id}>
                                <div className="flex flex-col md:w-[30%] space-y-2 sm:px-4 md:px-5 lg:px-5 xl:px-8">
                                    <p className="m-0 text-xs text-[#6A6A6A] pl-3">
                                    
                                    </p>
                                    <Form.Item name={elem.input} className="m-0">
                                        <InputMask
                                        className="bg-white border px-3 py-2 rounded-lg"
                                        mask={elem?.mask}
                                        />
                                    </Form.Item>
                                </div>
                                </Fragment>
                            );
                            }
                            if (elem.type === "file") {
                            return (<>
                                {/*<Fragment key={elem.id}>
                                <div className="flex flex-col space-y-2 sm:px-4 md:px-5 lg:px-5 xl:px-8">
                                    <p className="text-xs m-0 pl-3 text-[#6A6A6A]">
                                    {elem.input}
                                    </p>
                                    <label
                                    className="flex hover:cursor-pointer border-2 py-2 px-4 rounded-full"
                                    htmlFor="fileUploader"
                                    >
                                    {" "}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="#006D7D"
                                        className="w-6 h-6"
                                    >
                                        <path
                                        fillRule="evenodd"
                                        d="M11.47 2.47a.75.75 0 011.06 0l4.5 4.5a.75.75 0 01-1.06 1.06l-3.22-3.22V16.5a.75.75 0 01-1.5 0V4.81L8.03 8.03a.75.75 0 01-1.06-1.06l4.5-4.5zM3 15.75a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z"
                                        clipRule="evenodd"
                                        />
                                    </svg>
                                    <Form.Item name={elem.input} className="m-0">
                                    <input
                                        type="file"
                                        id="fileUploader"
                                        style={{ display: "none" }}
                                        onChange={this.handleFile}
                                        name={elem.input}
                                    />
                                    </Form.Item>
                                    <div className="pl-4 text-[#006D7D]">
                                        {translation("CHOOSE_FILE")}
                                    </div>
                                    </label>
                                </div>
                            </Fragment>*/}</>
                            );
                            }

                            return (
                            <Fragment key={elem.id}>
                                <div className="flex flex-col md:w-[30%] space-y-2 sm:px-4 md:px-5 lg:px-5 xl:px-8">
                                <p className="m-0 text-xs text-[#6A6A6A] pl-3">
                                    {elem.input}
                                </p>
                                <Form.Item name={elem.input} className="m-0">
                                <Input
                                    className="bg-white border px-3 py-2 rounded-lg"
                                    type={elem.type}
                                    name={elem.input}
                                />
                                 </Form.Item>
                                </div>
                            </Fragment>
                            );
                        })}
                        
                    </div>
                    <div className="sm:block md:flex bg-[#fff] rounded-b-[8px] py-4 shadow-lg">
                        <div className="flex flex-col md:w-[30%] space-y-2 sm:px-4 md:px-5 lg:px-5 xl:px-8">
                            <Checkbox 
                                value={this.state.contractChecked} 
                                onChange={this.contractHandler}
                                className="text-red-500 font-bold"
                            >Шахсонӣ ҳуқуқӣ</Checkbox>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div className="block w-full">
                <div className="w-[100%] md:px-[2rem]">
                <Table
                    footer={()=>{
                        return(
                            
                            <div className="w-full flex justify-end">
                                <Form.Item>
                            <Button htmlType="submit" 
                                disabled={this.state.submitButtonDisabled} 
                                className="text-white bg-emerald-600 hover:bg-white">
                                <div className="flex items-center">
                                <div className="flex mr-4 items-center">
                                    <CheckCircleOutlined color="#fff" />
                                </div>
                                <div>{t("CREATE_INVOICE")}</div>
                                </div>
                            </Button>
                            </Form.Item>
                            </div>
                        )}
                    }
                    className="shadow-lg"
                    columns={isMobile ? form_columns.filter((elem, index) => index !== 1 ): form_columns}
                    dataSource={formItem.services}
                    pagination={false}
                    size="small"
                    summary={()=>{
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell className="text-right" index={1} colSpan={isMobile  ? 3 : 4}>
                                    <div className="text-red-500 tracking-wide font-bold uppercase">{`${translation("TOTAL_INVOICE_AMOUNTS")} (${translation("TJS")}):`}</div>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell className="text-right" index={2} colSpan={1}>
                                    <div className="text-red-500 tracking-wide font-bold">{grandTotal.toFixed(2)}</div>
                                </Table.Summary.Cell>
                              </Table.Summary.Row>
                        )
                    }}
                    
                ></Table>
                </div>  
            </div>
            </Form>
        </div>
    }
    </div>
)}
}

export default withRouter(FillForm);